import managementImg from 'assets/images/manage.png';

const generalRootAdmin = {
    id: 'general',
    title: 'Root Admin',
    type: 'group',
    children: [
        {
            id: 'management',
            title: 'Management',
            type: 'collapse',
            icon: managementImg,
            children: [
                {
                    id: 'license',
                    title: 'Licenses',
                    type: 'item',
                    url: '/management/licenses',
                    breadcrumbs: false
                },
                {
                    id: 'organization',
                    title: 'Organizations',
                    type: 'item',
                    url: '/management/organizations',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default generalRootAdmin;
